// extracted by mini-css-extract-plugin
export var linkText = "_q4-0";